// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billingLink_AaPFs {
    display: inline-block !important;
}

@media ( max-width: 767px ) {
    .billingDashboard_baOeD {
      flex-direction: column !important;
      align-items : stretch !important;
      justify-content: space-between;
    }
    .body__9Zwq {
        flex-direction: column !important;
        align-items : stretch !important;
    }
    .cardBody_i2AT5 {
        border-bottom: 1px solid var(--color-base100);
        padding: var(--size-padLarge);
        margin: 0px !important;
    }
    .mobileheader_nYor5 {
        flex-direction: row !important;
        justify-content: space-between !important;
        margin: 0px !important;
    }
    .billingValue_Bny6l {
        margin : 0px !important;
    }
  }

`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/billing/views/BillingViewer.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;AACpC;;AAEA;IACI;MACE,iCAAiC;MACjC,gCAAgC;MAChC,8BAA8B;IAChC;IACA;QACI,iCAAiC;QACjC,gCAAgC;IACpC;IACA;QACI,6CAA6C;QAC7C,6BAA6B;QAC7B,sBAAsB;IAC1B;IACA;QACI,8BAA8B;QAC9B,yCAAyC;QACzC,sBAAsB;IAC1B;IACA;QACI,uBAAuB;IAC3B;EACF","sourcesContent":[".billingLink {\n    display: inline-block !important;\n}\n\n@media ( max-width: 767px ) {\n    .billingDashboard {\n      flex-direction: column !important;\n      align-items : stretch !important;\n      justify-content: space-between;\n    }\n    .body {\n        flex-direction: column !important;\n        align-items : stretch !important;\n    }\n    .cardBody {\n        border-bottom: 1px solid var(--color-base100);\n        padding: var(--size-padLarge);\n        margin: 0px !important;\n    }\n    .mobileheader {\n        flex-direction: row !important;\n        justify-content: space-between !important;\n        margin: 0px !important;\n    }\n    .billingValue {\n        margin : 0px !important;\n    }\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"billingLink": `billingLink_AaPFs`,
	"billingDashboard": `billingDashboard_baOeD`,
	"body": `body__9Zwq`,
	"cardBody": `cardBody_i2AT5`,
	"mobileheader": `mobileheader_nYor5`,
	"billingValue": `billingValue_Bny6l`
};
export default ___CSS_LOADER_EXPORT___;
